export class InstallerBridgeMockService {
  public setFileOperationView = async (): Promise<void> => undefined;

  public subscribe = async (): Promise<number> => -1;

  public unsubscribe = async (): Promise<boolean> => false;
}
